<template>
  <div
    :class="[prefix, `${prefix}-wrap`]"
    @mouseleave="hideDetail()"
  >
    <div class="nav-side">
      <ul v-if="categoryGroups.length > 0">
        <li
          v-for="(groupItem, index) in categoryGroups"
          :key="`${groupItem.Id}-${index}`"
          @mouseenter="showDetail(groupItem.Id)"
        >
          <!-- <img :src="groupItem.PictureUrl" style="width:20px;height:20px;" /> -->
          <span :class="[groupItem.PictureIconClass]">
          </span>
          <div
            v-for="(catItem, index) in groupItem.Categories"
            :key="`${catItem.Id}-${index}`"
            class="name"
          >
            <span
              v-for="(name, index) in catItem.Names"
              :key="index"
              @click="toProductList(catItem.Id)"
            > {{name}}
            </span>
          </div>
        </li>
      </ul>
    </div>
    <transition name="fade">
      <div
        class="detail-item-panel"
        :duration="{ enter: 100, leave: 500 }"
        v-show="panelVisible"
      >
        <div class="sub-rows">
          <div
            v-for="(item) in groupedSubCategories"
            :key="item.Id"
            class="detail-item-row"
          >
            <div
              class="detail-item-title detail-item"
              @click="toProductList(item.Id)"
            >
              <span class="">{{item.Name}}</span>
            </div>
            <div class="sub-items">
              <span
                v-for="(subItm) in item.SubCategories"
                :key="subItm.Id"
                class="detail-item"
                @click="toProductList(subItm.Id)"
              >
                <span class="split"></span>
                {{subItm.Name}}
              </span>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import '@/styles/components/category/categoryNav.scss';
import { mapState, mapActions } from 'vuex';
const prefix = 'cpt-category-nav';
export default {
  name: 'CategoryNav',
  inject: ['reloadBody'],
  data () {
    return {
      prefix,
      panelVisible: false,
      categoryGroups: [],
      allCategories: [],
      groupedSubCategories: []
    };
  },
  computed: {
    ...mapState({
      loginUserInfo: state => state.loginUserInfo
    })
  },
  methods: {
    ...mapActions({
      getCategoryGroups: 'getCategoryGroups'
    }),
    toProductList (id) {
      this.$router.push({
        path: '/productList',
        query: {
          categoryId: id
        }
      });
      this.reloadBody();
    },
    showDetail (gId) {
      const categoryGroup = this._.find(this.categoryGroups, ['Id', gId]);
      this.groupedSubCategories = categoryGroup.SubCategories;
      this.panelVisible = true;
    },
    hideDetail () {
      this.panelVisible = false;
    }
  },
  created () {
    this.getCategoryGroups()
      .then(result => {
        if (result.Success && result.Data) {
          this.allCategories = result.Data.AllCategories;
          this._.forEach(result.Data.Items, (gItem) => {
            gItem.Ids = [];
            this._.forEach(gItem.Categories, (cat) => {
              const str = cat.Name.replace(/\s+/ig, ' ');
              cat.Names = this._.split(str, ' ');
              gItem.Ids.push(cat.Id);
            });
            gItem.SubCategories = this._.filter(this.allCategories, (item) => { return this._.find(gItem.Categories, ['Id', item.ParentCategoryId]) !== undefined; });
            this._.forEach(gItem.SubCategories, (cat) => {
              cat.SubCategories = this._.filter(this.allCategories, (item) => { return item.ParentCategoryId === cat.Id; });
            });
          });
          this.categoryGroups = result.Data.Items;
        }
      })
      .catch(error => {
        console.log('error:', error);
      });
  },
  mounted () {
  },
  updated () {
  }
};
</script>

<style scoped lang='scss'>
</style>



// WEBPACK FOOTER //
// src/components/category/CategoryNav.vue